import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';
import { GlobalVariables } from '../services/local/globalVariables.service';

@Component({
  selector: 'app-redirect-event',
  template: '<div style="padding:24px;text-align:center;"><mat-spinner diameter="40"></mat-spinner><div style="margin-top:12px">Redirigiendo...</div></div>'
})
export class RedirectEventComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private auth: AuthService,
    private globalVariables: GlobalVariables
  ) {}

  ngOnInit(): void {
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    if (!id) {
      this.router.navigate(['/']);
      return;
    }

    let token = sessionStorage.getItem('authToken');
    if (!token) {
      // try to restore from localStorage so new tabs inherit login
      const tokenLocal = localStorage.getItem('authToken');
      const extrasLocal = localStorage.getItem('authTokenExtras') || '';
      if (tokenLocal) {
        try{ this.auth.saveToken(tokenLocal, extrasLocal); }catch(e){}
        token = tokenLocal;
      }
    }
    if (!token) {
      this.router.navigate(['/login'], { queryParams: { returnUrl: `/event/${id}` } });
      return;
    }

    this.api.service('/calendarDetail/' + id, 'get').subscribe(
      (res: any) => {
        const payload: any = res || {};
        const maybe = payload.calendarDetail ? payload.calendarDetail : payload;
        const d: any = Array.isArray(maybe) ? maybe[0] : (maybe.calendarDetail ? maybe.calendarDetail : maybe);

        // try to infer workplace id/name from calendarDetail
        let inferredWorkPlaceId = d?.idWorkPlace || d?.workPlaceId || d?.workplaceId || d?.workPlace?.id || null;
        let inferredWorkPlaceName = d?.workPlace?.name || d?.workplace?.name || d?.enterprise || d?.name || '';

        // fallback: extract workplace id/name from calendars array if present
        if ((!inferredWorkPlaceId || !inferredWorkPlaceName) && d && d.calendars && d.calendars.length) {
          for (const c of d.calendars) {
            const cal = c && c.calendar ? c.calendar : null;
            if (cal) {
              if (!inferredWorkPlaceId && (cal.idWorkPlace || cal.id_workplace || cal.idWorkplace || cal.workPlaceId)) {
                inferredWorkPlaceId = cal.idWorkPlace || cal.id_workplace || cal.idWorkplace || cal.workPlaceId;
              }
              if (!inferredWorkPlaceName && (cal.name || cal.shortName)) {
                inferredWorkPlaceName = cal.name || cal.shortName;
              }
              if (inferredWorkPlaceId && inferredWorkPlaceName) break;
            }
          }
        }

        // Now query workplaces endpoint to get the definitive workplace data
          this.api.service('/workplaces', 'get').subscribe((wps: any) => {
            // accept different payload shapes: array directly, or object with workPlaces/workplaces key
            const workplaces: any[] = Array.isArray(wps) ? wps : (wps && (wps.workPlaces || wps.workplaces) ? (wps.workPlaces || wps.workplaces) : []);

            let chosen: any = null;
            if (inferredWorkPlaceId) {
              chosen = workplaces.find(w => (w.idWorkPlace == inferredWorkPlaceId) || (w.id == inferredWorkPlaceId) || (w.idWorkplace == inferredWorkPlaceId) || (String(w.idWorkPlace) === String(inferredWorkPlaceId)));
            }
            // if not found by id, try to match by name/enterprise (case-insensitive, trim)
            if (!chosen && inferredWorkPlaceName) {
              const nameToMatch = String(inferredWorkPlaceName).trim().toLowerCase();
              chosen = workplaces.find(w => {
                const wn = w && (w.name || w.shortName || w.NAME) ? String(w.name || w.shortName || w.NAME).trim().toLowerCase() : '';
                const ent = w && (w.enteprise || w.enterprise || (w.company && w.company.erpCode)) ? String(w.enteprise || w.enterprise || (w.company && w.company.erpCode)).trim().toLowerCase() : '';
                return (wn && wn === nameToMatch) || (ent && ent === nameToMatch);
              });
            }
          // if still not found, try to pick workplace from globalVariables
          if (!chosen) {
            const gvId = this.globalVariables.getIdWorkPlace();
            if (gvId) chosen = workplaces.find(w => w.idWorkPlace == gvId || w.id == gvId || w.idWorkplace == gvId);
          }

          // if we found workplace use its canonical data otherwise fall back to inferred values
          const wpId = chosen ? (chosen.idWorkPlace || chosen.id || chosen.idWorkplace) : inferredWorkPlaceId || this.globalVariables.getIdWorkPlace();
          const wpName = chosen ? (chosen.name || chosen.shortName || chosen.enterprise || inferredWorkPlaceName) : inferredWorkPlaceName || '';
          const wpEnterprise = chosen ? (chosen.enterprise || d?.enterprise) : d?.enterprise;
          const wpAddress = chosen ? (chosen.address || d?.address) : d?.address;

          localStorage.setItem('inhouseWorkPlace', chosen.inhouseWorkPlace.toString())
          

          if (!wpId) {
            this.router.navigate(['/main']);
            return;
          }

          const loggedUserName = localStorage.getItem('userName');
          // if we found a canonical workplace, prefer its name/address/enterprise for route and params
          const finalWpName = wpName || inferredWorkPlaceName || '';
          const targetName = finalWpName || (loggedUserName ? decodeURIComponent(loggedUserName) : '');
          // send calendarDetail in the normalized object form so ResourcesViewCalendarComponent
          // will parse it the same way as when opened from in-app links.
          // try to include the event date so ResourcesViewCalendarComponent opens that day
          let eventDate = d && (d.dateFrom || d.date || (d.calendarDetail && (d.calendarDetail.dateFrom || d.calendarDetail.date))) ? (d.dateFrom || d.date || d.calendarDetail.dateFrom || d.calendarDetail.date) : null;
          // if we only have a YYYY-MM-DD date, convert to an ISO-like string with timezone
          if (eventDate && typeof eventDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(eventDate)) {
            eventDate = `${eventDate}T00:00:00+00:00`;
          }
          const calendarDetailParam = eventDate ? JSON.stringify({ idDetail: { idDetail: id, date: eventDate } }) : JSON.stringify({ idDetail: { idDetail: id } });
          const queryParams: any = { calendarDetail: calendarDetailParam, idWorkPlace: wpId };
          // prefer canonical workplace fields when available
          // workplace API uses 'enteprise' or nested company.erpCode
          if (chosen && (chosen.enteprise || chosen.enterprise)) queryParams.enterprise = (chosen.enteprise || chosen.enterprise);
          else if (chosen && chosen.company && chosen.company.erpCode) queryParams.enterprise = chosen.company.erpCode;
          else if (wpEnterprise) queryParams.enterprise = wpEnterprise;
          if (chosen && chosen.address) queryParams.address = chosen.address;
          else if (wpAddress) queryParams.address = wpAddress;
          if (finalWpName) queryParams.name = finalWpName;

          // set global variables as if the user selected the workplace in the UI
          try{
            this.globalVariables.setIdWorkPlace(wpId);
            if (chosen && chosen.phone) this.globalVariables.setphoneWorkPlace(chosen.phone);
            if (chosen && (chosen.clientErpCode || (chosen.company && chosen.company.erpCode))) this.globalVariables.setClientErpCode(chosen.clientErpCode || (chosen.company && chosen.company.erpCode));
          }catch(e){/* ignore */}

          

          // call workweekActive to mirror selection flow, then navigate
          this.api.service('/workweekActive/' + wpId, 'get').subscribe(()=>{
            this.router.navigate(['resources', wpId, targetName], { queryParams, replaceUrl: true, queryParamsHandling: 'merge' });
          }, ()=>{
            // even if this fails, still navigate
            this.router.navigate(['resources', wpId, targetName], { queryParams, replaceUrl: true, queryParamsHandling: 'merge' });
          });
        }, _errWp => {
          // if workplaces fetch fails, fallback to previous inference
          const wpId = inferredWorkPlaceId || this.globalVariables.getIdWorkPlace();
          const targetName = inferredWorkPlaceName ? inferredWorkPlaceName : (localStorage.getItem('userName') || '');
          if (!wpId) { this.router.navigate(['/main']); return; }
          const calendarDetailParam = JSON.stringify({ idDetail: { idDetail: id } });
          const queryParams: any = { calendarDetail: calendarDetailParam, idWorkPlace: wpId };
          if (d && d.enterprise) queryParams.enterprise = d.enterprise;
          if (d && d.address) queryParams.address = d.address;
          if (targetName) queryParams.name = targetName;
          this.router.navigate(['resources', wpId, targetName], { queryParams, replaceUrl: true, queryParamsHandling: 'merge' });
        });
      },
      (err) => {
        this.router.navigate(['/main']);
      }
    );
  }
}
